<template>
  <div>
    <el-row class="wenzi">
      <span>员工账号</span>

      <el-button type="primary" class="btn" @click="copyrightCertificate()">
        添加子账号
      </el-button>
    </el-row>
    <el-row>
      <el-table :data="tableData" border class="table-dci">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="用户编号" prop="userId"> </el-table-column>
        <el-table-column
          label="联系人手机"
          prop="phonenumber"
        ></el-table-column>
        <el-table-column label="用户名称" prop="userName"></el-table-column>
        <el-table-column label="开户日期" prop="createTime">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template></el-table-column
        >

        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            <!-- {{ scope.row.status === '0' ? '启用' : '停用' }} -->
            <el-switch
              v-model="scope.row.status"
              active-value="0"
              inactive-value="1"
              @change="handleStatusChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="workFeedInfoClick(scope.row)"
              >重置密码</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- 添加或修改用户配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="79.9988px">
        <el-row v-if="false">
          <el-col :span="12">
            <el-form-item label="用户名称" prop="userName">
              <el-input
                v-model="form.userName"
                placeholder="请输入用户昵称"
                maxlength="30"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="phonenumber">
              <el-input
                v-model="form.phonenumber"
                placeholder="请输入手机号码"
                maxlength="11"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              v-if="form.userId == undefined"
              label="用户密码"
              prop="password"
            >
              <el-input
                v-model="form.password"
                placeholder="请输入用户密码"
                type="password"
                maxlength="20"
                show-password
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  systemUserList,
  resetUserPwd,
  changeUserStatus,
  addUser,
  updateUser
} from '@/api/user.js'

export default {
  name: '',
  components: {},
  mixins: [],
  props: {},
  data () {
    return {
      // 表单校验
      rules: {
        userName: [
          { required: true, message: '用户名称不能为空', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '用户名称长度必须介于 2 和 20 之间',
            trigger: 'blur'
          }
        ],
        nickName: [
          { required: true, message: '用户昵称不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' },
          {
            min: 5,
            max: 20,
            message: '用户密码长度必须介于 5 和 20 之间',
            trigger: 'blur'
          },
          {
            pattern: /^[^<>"'|\\]+$/,
            message: '不能包含非法字符：< > " \' \\\ |',
            trigger: 'blur'
          }
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        phonenumber: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ]
      },
      tableData: [],
      form: {
        deptId: 105,
        userName: '',
        nickName: '',
        password: '',
        status: '0',
        phonenumber: '',
        postIds: [],
        roleIds: []
      },
      open: false,
      title: ''
    }
  },

  async created () {
    this.reset()
  },
  computed: {},
  watch: {},
  mounted () {},
  methods: {
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.form.nickName = this.form.phonenumber
          this.form.userName = this.form.phonenumber
          this.form.bossUserId = this.$store.state.userInfo.user.userId
          if (this.form.userId != undefined) {
            updateUser(this.form).then(response => {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.open = false
              this.reset()
            })
          } else {
            addUser(this.form).then(response => {
              this.$message({
                message: '新增成功',
                type: 'success'
              })
              this.open = false
              this.reset()
            })
          }
        }
      })
    },
    async reset () {
      const res = await systemUserList({
        pageNum: 1,
        pageSize: 500,
        deptId: 105,
        isAsc: 'desc',
        orderByColumn: 'createTime',
        bossUserId: this.$store.state.userInfo.user.userId
      })
      if (res.code === 200) {
        console.log(res)

        this.tableData = res.rows
      }
    },
    copyrightCertificate () {
      this.open = true
      this.title = '添加用户'
    },
    handleStatusChange (row) {
      let text = row.status === '0' ? '启用' : '停用'
      this.$confirm(
        '确认要"' + text + '""' + row.userName + '"用户吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(function () {
          return changeUserStatus(row.userId, row.status)
        })
        .then(() => {
          this.$message.success(text + '成功')
        })
        .catch(function () {
          row.status = row.status === '0' ? '1' : '0'
        })
    },
    workFeedInfoClick (row) {
      this.$prompt('请输入"' + row.userName + '"的新密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        inputPattern: /^.{5,20}$/,
        inputErrorMessage: '用户密码长度必须介于 5 和 20 之间',
        inputValidator: value => {
          if (/<|>|"|'|\||\\/.test(value)) {
            return '不能包含非法字符：< > " \' \\\ |'
          }
        }
      })
        .then(({ value }) => {
          resetUserPwd(row.userId, value).then(response => {
            this.$message.msgSuccess('修改成功，新密码是：' + value)
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.wenzi {
  height: 80px;
  margin-left: 50px;
  text-align: center;
  line-height: 80px;

  letter-spacing: normal;
  color: #333333;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}
.btn {
  margin-left: 952px;
}
</style>
